import React from 'react';
import { ShieldCheck, Lock, CreditCard } from 'lucide-react';
import { CountdownTimer } from './CountdownTimer';
export function Footer() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <footer className="bg-[#0a1628] border-t border-slate-800 pt-20 pb-10 px-4" data-id="element-104">
      <div className="max-w-4xl mx-auto" data-id="element-105">
        {/* Final CTA Section inside footer area for flow */}
        <div className="text-center mb-20" data-id="element-106">
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-8" data-id="element-107">
            "El próximo lunes puede ser diferente."
          </h2>

          <div className="max-w-md mx-auto mb-10" data-id="element-108">
            <p className="text-[#d4a843] font-bold mb-4 uppercase tracking-wider text-sm" data-id="element-109">
              Última chance al precio de lanzamiento
            </p>
            <CountdownTimer data-id="element-110" />
          </div>

          <div className="flex flex-col sm:flex-row justify-center gap-4 mb-10" data-id="element-111">
            <button onClick={scrollToPricing} className="px-8 py-4 rounded-xl font-bold text-white bg-slate-800 hover:bg-slate-700 transition-colors border border-slate-600" data-id="element-112">
              📘 MEGAPACK ($19.990)
            </button>
            <button onClick={scrollToPricing} className="px-8 py-4 rounded-xl font-bold text-[#0a1628] bg-gradient-to-r from-[#d4a843] to-[#fcebb6] hover:scale-105 transition-transform shadow-lg" data-id="element-113">
              🏆 MEGAPACK + EL CIERRE ($27.990)
            </button>
          </div>

          <div className="flex flex-wrap justify-center items-center gap-4 md:gap-6 text-sm text-slate-400" data-id="element-114">
            <span className="flex items-center gap-1" data-id="element-115">
              <Lock className="w-4 h-4 text-[#d4a843]" data-id="element-116" /> Pago 100% seguro
            </span>
            <span className="flex items-center gap-1" data-id="element-117">
              ⚡ Acceso en 5 minutos
            </span>
            <span className="flex items-center gap-1" data-id="element-118">
              <ShieldCheck className="w-4 h-4 text-[#d4a843]" data-id="element-119" /> Garantía 7 días
            </span>
            <span className="flex items-center gap-1" data-id="element-120">
              <CreditCard className="w-4 h-4 text-[#d4a843]" data-id="element-121" /> Mercado Pago |
              Tarjeta
            </span>
          </div>
        </div>

        {/* Actual Footer Links/Info */}
        <div className="border-t border-slate-800/50 pt-10 flex flex-col md:flex-row justify-between items-center gap-6 text-center md:text-left" data-id="element-122">
          <div data-id="element-123">
            <div className="font-bold text-white text-xl mb-2" data-id="element-124">
              📚 BIBLIOTECAS DIGITALES™
            </div>
            <p className="text-slate-400 text-sm max-w-md" data-id="element-125">
              El sistema de búsqueda laboral N°1 para profesionales en
              Argentina. Porque conseguir trabajo no debería costarte todos los
              fines de semana.
            </p>
          </div>

          <div className="text-sm text-slate-400 space-y-2" data-id="element-126">
            <p data-id="element-127">📧 soportebibliotecasdigitales@gmail.com</p>
            <p data-id="element-128">🌐 www.bibliotecasdigitales.store</p>
            <p className="pt-4" data-id="element-129">
              © Bibliotecas Digitales™ 2024 — Todos los derechos reservados.
            </p>
          </div>
        </div>
      </div>
    </footer>;
}